import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "./ContainerCreate";
import { getMessageBoard } from "../api/getMessageBoard";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

class MessageBoardContainer extends React.Component {
  componentDidMount() {
    const { page } = this.props;
    this.props.request(page);
  }
  componentWillReceiveProps(nextProps) {
    const { page: nextPage, refresh: nextRefresh } = nextProps;
    const { page, refresh } = this.props;
    if (nextPage !== page) {
      this.props.request(nextPage);
    }
    if (refresh !== nextRefresh) {
      this.props.request(1);
    }
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const topics = (data && data.data) || [];
    if (loading) {
      return (
        <SkeletonTheme color="#ccc" highlightColor="#ddd">
          <Skeleton count={6} />
        </SkeletonTheme>
      );
    }
    if (!loading && topics.length === 0) {
      return null;
    }

    return render({ topics, loading, failure });
  };
}

MessageBoardContainer.propTypes = {
  page: PropTypes.number,
};
MessageBoardContainer.defaultProps = {
  page: 1,
};

export default CreateContainer(getMessageBoard, MessageBoardContainer);
